// src/pages/admin/components/SectionEditorModal/pickers/LayoutAlignmentSelector.jsx
import React from "react";
import {
  ViewColumnsIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowsPointingOutIcon,
  CheckIcon,
} from "@heroicons/react/24/outline";

const ALIGN_OPTIONS = [
  { value: "left", label: "Left", Icon: ArrowLeftIcon, description: "Left aligned" },
  { value: "center", label: "Center", Icon: ArrowsPointingOutIcon, description: "Center aligned" },
  { value: "right", label: "Right", Icon: ArrowRightIcon, description: "Right aligned" },
];

export default React.memo(function LayoutAlignmentSelector({ value, onChange, t }) {
  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
        <ViewColumnsIcon className="w-4 h-4" />
        {t("sectionModal.alignment.title", "Content Alignment")}
      </label>

      <div className="grid grid-cols-3 gap-2">
        {ALIGN_OPTIONS.map(({ value: v, label, Icon, description }) => {
          const active = value === v;
          return (
            <button
              key={v}
              type="button"
              onClick={() => onChange(v)}
              className={`relative flex flex-col items-center justify-center p-3 rounded-xl border-2 transition-all
                ${active ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"}
              `}
            >
              <div className={`mb-2 p-2.5 rounded-lg ${active ? "bg-blue-100 text-blue-600" : "bg-gray-100 text-gray-600"}`}>
                <Icon className="w-5 h-5" />
              </div>

              <span className="text-xs font-medium text-gray-700 mb-0.5">{label}</span>
              <span className="text-xs text-gray-500">{description}</span>

              {active ? (
                <div className="absolute top-1.5 right-1.5">
                  <div className="w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center">
                    <CheckIcon className="w-3 h-3 text-white" />
                  </div>
                </div>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
});